// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_fee_management_system_ui_styles" + "." + "7e0d6e06" + ".chunk.css";
};